module.exports = __webpack_public_path__ + "img/titleEle.fc5972b3.svg";